import React, { useRef } from 'react';

import { BackdropSpinner } from '_lib/components/BackdropSpinner/BackdropSpinner';
import { Button } from '_lib/components/Button/Button';
import { Divider } from '_lib/components/Divider/Divider';
import { ErrorDetailsAccordion } from '_lib/components/ErrorDetailsAccordion/ErrorDetailsAccordion';
import { ErrorDisplay } from '_lib/components/ErrorDisplay/ErrorDisplay';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';
import { Stack } from '_lib/components/Stack/Stack';
import { useIsOverflowing } from '_lib/hooks/useIsOverflowing';

export type FormWrapperProps = {
  children: React.ReactNode;
  formValues: object;
  onSave: () => void;
  disabled?: boolean;
  validationErrors?: string[];
  allErrors?: string[];
  isFetchingOrPending?: boolean;
};

/** TODO: possibly reuse this for less complicated routes */
export const FormWrapper = (props: FormWrapperProps) => {
  const { children, formValues, onSave, disabled, validationErrors, allErrors, isFetchingOrPending } = props;

  const scrollTriggerTarget = useRef<HTMLDivElement>(null);
  const { isOverflowing } = useIsOverflowing(scrollTriggerTarget);

  return (
    <FlexBox
      sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      })}>
      <BackdropSpinner open={!!isFetchingOrPending} />
      {!!Object.keys(formValues).length && (
        <>
          <Stack padding={2} useFlexGap spacing={2} overflow='auto' ref={scrollTriggerTarget}>
            {!!validationErrors?.length && <ErrorDisplay errors={validationErrors} sx={{ borderRadius: 1 }} />}
            {!!allErrors?.length && <ErrorDetailsAccordion errors={allErrors} />}
            {children}
          </Stack>
          {isOverflowing && <Divider />}
          <FlexBox sx={{ paddingX: 2, paddingY: 1, marginLeft: 'auto' }}>
            <Button
              disabled={disabled}
              onClick={onSave}
              text='Save'
              variant='contained'
              size='small'
              sx={{ textTransform: 'none' }}
            />
          </FlexBox>
        </>
      )}
    </FlexBox>
  );
};
